import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const Index = () => {
  const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [showOrderTypePopup, setShowOrderTypePopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (!tableData) {
      setError("Something went wrong. Please scan the QR code again");
      return;
    }

    // If table number is 1, redirect to ViewMenuOptions
    if (Number(tableData.actualTableNumber) === 1) {
      navigate(
        `/ezmenu/options/${tableData.tableNumer}/${tableData.rvc}/${tableData.zone}/${tableData.actualTableNumber}`
      );
      return; // Stop further execution for this case
    }
    // If table number is 2 or more, show the payment selection popup
    if (Number(tableData.actualTableNumber) >= 2) {
      setShowOrderTypePopup(true);
    }
  }, [tableData, navigate]); // Add tableData and navigate to dependency array

  const handleMenuNavigation = (orderType) => {
    setSelectedOption(orderType);
    
    // Add a small delay for animation
    setTimeout(() => {
      const currentOrderType = sessionStorage.getItem("orderType");
      if (currentOrderType && currentOrderType !== orderType) {
        // Clear all session storage items related to previous orders
        sessionStorage.removeItem("cartData");
        sessionStorage.removeItem("checkData");
        sessionStorage.removeItem("orderReference");
        sessionStorage.removeItem("paymentAmount");
        sessionStorage.removeItem("generalComment");
        sessionStorage.removeItem("orderId");
        sessionStorage.removeItem("guestDetails");
      }
      sessionStorage.setItem("orderType", orderType);
      setIsClosing(true);
      
      setTimeout(() => {
        setShowOrderTypePopup(false);
        setIsClosing(false);
        setSelectedOption(null);
        // Navigate to the parameterized ViewMenuOptions route
        navigate(
          `/ezmenu/options/${tableData.tableNumer}/${tableData.rvc}/${tableData.zone}/${tableData.actualTableNumber}`
        );
      }, 300);
    }, 400);
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowOrderTypePopup(false);
      setIsClosing(false);
    }, 300);
  };

  return (
    <div className="lp-landing-container">
      {error && (
        <div className="lp-error-toast">
          <span className="lp-error-icon">⚠️</span>
          <span>{error}</span>
        </div>
      )}

      {/* -------- MODERN ORDER TYPE POPUP -------- */}
      {showOrderTypePopup && (
        <div className={`lp-modal-overlay ${isClosing ? 'lp-closing' : ''}`}>
          <div className={`lp-modal-content ${isClosing ? 'lp-closing' : ''}`}>
            
            {/* Add logo at the top of modal */}
            <div className="lp-modal-logo-container">
              <img
                src="/images/Wild-Wadi-Logo_white.png"
                alt="EZmenu"
                className="lp-modal-logo"
              />
            </div>

            <div className="lp-modal-options">
              {/* Room Posting Option */}
              <button
                className={`lp-option-card ${selectedOption === 'room_posting' ? 'lp-selected' : ''}`}
                onClick={() => handleMenuNavigation("room_posting")}
              >
                <div className="lp-option-icon-wrapper">
                  <div className="lp-option-icon-bg"></div>
                </div>
                <div className="lp-option-content">
                  <h3 className="lp-option-title">Bill to Room</h3>
                </div>
                <div className="lp-option-arrow">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16666 10H15.8333M15.8333 10L11.6667 5.83337M15.8333 10L11.6667 14.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </button>

              {/* Online Payment Option */}
              <button
                className={`lp-option-card ${selectedOption === 'online_payment' ? 'lp-selected' : ''}`}
                onClick={() => handleMenuNavigation("online_payment")}
              >
                <div className="lp-option-icon-wrapper">
                  <div className="lp-option-icon-bg"></div>
                </div>
                <div className="lp-option-content">
                  <h3 className="lp-option-title"> Card Payment</h3>
                </div>
                <div className="lp-option-arrow">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16666 10H15.8333M15.8333 10L11.6667 5.83337M15.8333 10L11.6667 14.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;